"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../../../core/button"));
var _managePromotionModal = _interopRequireDefault(require("./manage-promotion-modal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // This displays the appropriate button to allow the user to manage promotions under certain circumstances
class PromotionManagement extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      isManagingPromotion: false
    });
    _defineProperty(this, "_onToggleRequest", () => {
      this.setState({
        isManagingPromotion: !this.state.isManagingPromotion
      });
    });
  }
  render() {
    const entry = this.props.entry;
    const today = new Date().toISOString().split('T')[0];
    const canManagePromotion = (entry.entryStatusRef === 'COMP' || entry.entryStatusRef === 'WAIT') && entry.promotion && entry.promotion.promotedToBibID && (!entry.promotion.dateOfPromotion || entry.promotion.dateOfPromotion < entry.race.competitionDay.dayDate) && today <= entry.race.competitionDay.dayDate;

    // once managing promotion has started don't drop out of process until specifically
    // decide to or entry is cancelled
    return /*#__PURE__*/_react.default.createElement("span", null, !canManagePromotion || this.state.isManagingPromotion ? null : /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onToggleRequest,
      block: true,
      size: "sm"
    }, "Manage Promotion")), !this.state.isManagingPromotion ? null : /*#__PURE__*/_react.default.createElement(_managePromotionModal.default, {
      onToggleRequest: this._onToggleRequest,
      entry: entry
    }));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(PromotionManagement, "partialQueries", {
  Entry: _mergeBqlQueries({
    id: true,
    entryStatusRef: true,
    promotion: {
      promotedToBibID: true,
      dateOfPromotion: true
    },
    race: {
      competitionDay: {
        dayDate: true
      }
    }
  }, _managePromotionModal.default.partialQueries.Entry)
});
var _default = exports.default = PromotionManagement;